export const baseUrl = process.env.REACT_APP_BASE_URL;

export const usersUrls = {
    sendLoginCode: `${baseUrl}/api/User/SendLoginCode`,
    login: `${baseUrl}/api/user/Login`,
    register: `${baseUrl}/api/Doctor/Register`,
    info: `${baseUrl}/api/Doctor/info?`,
    refreshToken: `${baseUrl}/api/User/RefreshToken`,
    notificationToken: `${baseUrl}/api/NotificationToken`,
    deleteNotificationToken: (fireBaseToken) => `${baseUrl}/api/NotificationToken?token=${fireBaseToken}`,
    getProvince: `${baseUrl}/api/Province`,
};
export const appUrls = {
    registerPatient: `${baseUrl}/api/Patient/RegisterByDoctor`,
    GlucoseChart: (id, daysAgo) => `${baseUrl}/api/GlucoseChart/${id}?daysAgo=${daysAgo}`,
    GlucoseChartAll: (id) => `${baseUrl}/api/GlucoseChart/All/${id}`,
    Logs: (id, pageNumber, pageSize) => `${baseUrl}/api/GlucoseTest/doctor/${id}?PageNumber=${pageNumber}&PageSize=${pageSize}`,
    getPatient: (pageNumber, pageSize) => `${baseUrl}/api/Doctor/patients?PageNumber=${pageNumber}&PageSize=${pageSize}`,
    NFCTransaction: `${baseUrl}/api/NFCTransaction/InsertByDoctor`,
    getPatientInfo: (id) => `${baseUrl}/api/Patient/${id}`,
    editPatient: (id) => `${baseUrl}/api/Patient/${id}`,
    currentUser: `${baseUrl}/api/User/CurrentUser`,
    GridGlucoseChart: (from, to, id) => `${baseUrl}/api/GlucoseChart/grid/${id}?from=${from}&to=${to}`,
    GetShareToken: (id) => `${baseUrl}/api/UserShareToken/${id}?validHours=72`,
    getSharedReportData: (token) => `${baseUrl}/api/SharedData/All?token=${token}`,
    getSharedLogbookData: (PageNumber, PageSize, token) => `${baseUrl}/api/SharedData/Filter?PageNumber=${PageNumber}&PageSize=${PageSize}&token=${token}`,
    getSharedUserInfo: (token) => `${baseUrl}/api/SharedData/User?token=${token}`,
    getSharedGridTable: (from, to, token) => `${baseUrl}/api/SharedData/grid?from=${from}&to=${to}&token=${token}`,
    sendSmsShareLink: (patientId, phoneNumber) => `${baseUrl}/api/UserShareToken/${patientId}/SendTextMessage?phoneNumber=${phoneNumber}`,
    updateUserProfile: `${baseUrl}/api/User/UpdateProfile`,
    agentDashboard: `${baseUrl}/api/Agent/Dashbaord`,
    hypoData :(patientId,daysAgo) => `${baseUrl}/api/GlucoseChart/hypo/${patientId}?daysAgo=${daysAgo}`,
    hypoListData :(patientId,daysAgo,status) => `${baseUrl}/api/GlucoseTest/${patientId}/filterByDays?daysAgo=${daysAgo}&status=${status}`,
    sendResponseToInvite:(id,isAccepted) => `${baseUrl}/api/Assistant/SetInviteStatus?token=${id}&isAccepted=${isAccepted}`,
    assistantInvite:(id) => `${baseUrl}/api/Assistant/invite/${id}`,
    doctorList: `${baseUrl}/api/Assistant/Doctors`,
    appType : `${baseUrl}/api/Test/env`

};